import { useQuery } from '@tanstack/react-query';

import { useReferenceAssistantGateway } from './ReferenceAssistantGatewayProvider';
import { getCitationRequestsByConversationV2QueryOptions } from '../api/queryOptions';

/** A conversation's citation requests, read through the gateway in context. */
export function useCitationRequests(conversationId: string, { enabled = true } = {}) {
  const gateway = useReferenceAssistantGateway();

  return useQuery(
    getCitationRequestsByConversationV2QueryOptions({ conversationId, enabled, gateway })
  );
}
